import { Injectable } from '@angular/core';
import { PackageService } from '../packages/package.service';
import { TranslateService } from '../translate/translate.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Injectable()
export class QueService {

  translations;

  constructor(private packageService: PackageService, private snackbar: SnackbarService, private ts: TranslateService) {
    this.translations = this.ts.get('general');
  }

  public async triggerPriority(packageId: string): Promise<any> {
    await this.packageService.patch(packageId, { 'cache.queuePriorityDynamicContent': 1 });
    const pak = (await this.packageService.get(packageId));
    pak.assignedChildPackages.forEach(id => {
      this.packageService.patch(id, { 'cache.queuePriorityDynamicContent': 1 });
    });
    this.snackbar.success(this.translations.queuePriorityDone,5000);
  }

  public async triggerPriorities(packageIds: string[]) {
    if (!Array.isArray(packageIds)) {
      packageIds = [packageIds];
    }
    for (const packageId of packageIds) {
      await this.packageService.patch(packageId, { 'cache.queuePriorityDynamicContent': 1 });
      const packages = (await this.packageService.find(0, 100, { _id: { $in: packageIds } }));
      setTimeout(() => {
        (packages.data.map(el => el.assignedChildPackages) as any).flat().forEach(id => {
          this.packageService.patch(id, { 'cache.queuePriorityDynamicContent': 1 });
        });
        this.snackbar.success(this.translations.queuePriorityDone,5000);
      }, 500);
    }
  }
}
